import React, { useEffect, useState } from "react";
import { Box, Button } from "@material-ui/core";
import { useHistory, Link as RouterLink } from "react-router-dom";
import { BaseItemState, OverviewCriteria } from "../Ticker2/Ticker2Models";
import FixtureOverviewUtil from "./FixtureOverviewUtil";
import CreateRoundUtil from "../CreateRound/CreateRoundUtil";
import RoundOverviewUtil from "../RoundOverview/RoundOverviewUtil";
import Ticker2Util from "../Ticker2/Ticker2Util";
import { ActionState, ExtFixtureFilter, ExtFixtureItem, FixtureNg } from "./FixtureOverviewModels";
import { GenericResponse } from "../CreateRound/CreateRoundModels";
import { ListResponse } from "../api/ApiNgModels";
import { UpdateItemState } from "../CreateSyndicate/CreateSyndicateModels";
import { blue } from "@material-ui/core/colors";
import ConfirmationDialog from "../Components/ConfirmationDialog";
import ExtFixtureTable from "./ExtFixtureTable";


interface ExtFixtureItemState extends BaseItemState<ExtFixtureItem,number> {
    fixtureNgId: number;
}
interface FixtureNgMappingViewProps {
    fixtureNg?: FixtureNg;
}
const FixtureNgMappingView: React.FC<FixtureNgMappingViewProps> = (props) => {
    var propsFixtureNgId = 0;
    var propsFixtureNgNme = "";
    if (props.fixtureNg) {
        propsFixtureNgId = props.fixtureNg.id;
        propsFixtureNgNme = props.fixtureNg.name;
    }
 
 
    const [itemState, setItemState] = useState<ExtFixtureItemState>({
        fixtureNgId: propsFixtureNgId,
        items: [],
        more: false,
        lastId: 0,
        refreshing: false
    });
    //const [actionError, setActionError] = useState<string>("");
    const [actionState, setActionState] = useState<ActionState>(FixtureOverviewUtil.createEmptyActionState());
    const [updateItemState, setUpdateItemState] = useState<UpdateItemState<ExtFixtureItem>>({
        method: 'none',
        item: undefined,
        handled: false,
        updateNo: 0,
        version: 0
    });
    const history = useHistory();   

    useEffect(() => {
        refreshItems("Init");
    }, []);

    const getFixtureMappings = async (lastId: number): Promise<GenericResponse<ListResponse<ExtFixtureItem>>> => {
        var filter : ExtFixtureFilter = {
            providerId: "",
            mapped: true 
        }
        var pageSize = 100;
        if (propsFixtureNgId <= 0) {
            return { success: true, message: "", item: {
                items: [],
                message: "",
                page: 0,
                pageSize: pageSize,
                size: 0,
                success: true,
                totalPages: 0,
                totalSize: 0
            }};
        }
        filter.fixtureNgId = propsFixtureNgId;
        return await FixtureOverviewUtil.getExtFixtureItems(pageSize, undefined, undefined, lastId, filter);
    };
    const refreshItems = (caller: string) => {
        if (itemState.refreshing) {
            return;
        }
        var ast = FixtureOverviewUtil.createEmptyActionState();
        var rs : ExtFixtureItemState = {
            fixtureNgId: propsFixtureNgId,
            items: [],
            more: false,
            lastId: 0,
            refreshing: false
        }
        var lastId = caller === "onMore" ? itemState.lastId : 0;
        if (lastId > 0) {
            rs.items = itemState.items;
        }
        var success = false;
        itemState.refreshing = true;
        setActionState(FixtureOverviewUtil.createActionState(true, false, `RefreshItems(${caller})...`));
        getFixtureMappings(lastId).then( resp => {
            if (!resp.success) {
                //setActionError(`${caller} error: ${resp.message}`);
                ast.error = true;
                ast.message = `RefreshItems(${caller}) error: ${resp.message}`;
                return;
            }
            var listResponse = resp.item;
            if (listResponse) {
                if (listResponse.items) {
                    if (lastId > 0) {
                        for (const item of listResponse.items) {
                            rs.items.push(item);
                        }
                    } else {
                        rs.items = listResponse.items;
                    }
                    if (listResponse.items.length > 0) {
                        rs.lastId = listResponse.items[listResponse.items.length - 1].id;
                    }
                    if (listResponse.pageSize > 0 && listResponse.pageSize <= listResponse.items.length) {
                        rs.more = true;
                    }
                }           
            }
            success = true;
        }).catch( error => {
            //setActionError(CreateRoundUtil.getExceptionMessage(error, false, `${caller} error`));
            ast.error = true;
            ast.message = CreateRoundUtil.getExceptionMessage(error, false, `RefreshItems(${caller}) error`);
        }).finally( () => {
            if (success || lastId <= 0) {
                setItemState(rs);
            }
            itemState.refreshing = false;
            setActionState(ast);
        });
    };
    const onRefreshItems = () => {
        refreshItems("Refresh");
    };
    const onMore = () : void => {
        if (itemState.lastId <= 0) {
            //setActionError("More failure: LastId was not set");
            setActionState(FixtureOverviewUtil.createActionState(false, true, "More failure: LastId was not set."));
            return;
        }
        refreshItems("onMore");
    }
    const onDeleteItem = (item: ExtFixtureItem) => {
        if (!item) {
            setActionState(FixtureOverviewUtil.createActionState(false, true, "Fixture mapping is not specified."));
            return;
        }
        // if (item.mappingId && item.mappingId > 0) {
        //     setAction(FixtureOverviewUtil.createActionState(false, true, "Ext fixture is already mapped."));
        //     return;
        // }
        setUpdateItemState({
            method: 'remove',
            item: item,
            handled: false,
            updateNo: 0,
            version: 0
        });
    };
    const unmapFixture = (item: ExtFixtureItem) => {
        
        var ast = FixtureOverviewUtil.createEmptyActionState(); 
        setActionState(FixtureOverviewUtil.createActionState(true, false, "Unmapping fixture..."));
        var finished = false;
        FixtureOverviewUtil.unmapFixture(item.id).then((resp) => {
            if (!resp.success) {
                ast.error = true;
                ast.message = `Unmap Fixture error: ${resp.message}`;
                return;
            }
            var extFixtureIndex = itemState.items.findIndex(it => it.id === item.id);
            if (extFixtureIndex >= 0) {
                var ist = {...itemState, refreshing: false};
                ist.items.splice(extFixtureIndex, 1);
                setItemState(ist);
            }
        }).catch(error => {
            ast.error = true;
            ast.message = CreateRoundUtil.getExceptionMessage(error, false, "Unmap Fixture error");
        }).finally(() => {
            setActionState(ast);
        });
    };

    const onUnmapFixtureClose = (confirmed: boolean | undefined) : void => {
        if (updateItemState.handled) {
            return;
        }
        var ms = {...updateItemState, handled: true};
        setUpdateItemState(ms);
        if (!confirmed || !ms.item) {
            return;
        }
        unmapFixture(ms.item);      
    };    
    if (itemState.fixtureNgId !== propsFixtureNgId){
        itemState.items = [];
        refreshItems("ChangeFixture");
    }
    var isExecuting = itemState.refreshing || actionState.executing;
    var actionBox = null;
    if ((actionState.executing || actionState.error) && actionState.message.length > 0) {
        actionBox = (
            <Box color={actionState.error ? RoundOverviewUtil.INVALID_COLOR : blue[500]} fontSize={12}>
                {actionState.message}
            </Box>
        );
    }
    var info = Ticker2Util.toItemStateString(itemState);
    var moreBtn = null;
    if (itemState.more && !itemState.refreshing) {
        moreBtn = (<Button 
            variant="text"
            color="secondary"
            size="small"
            disabled={isExecuting}
            onClick={e => onMore()}>
            More
        </Button>);
    }

    var updateDialog = null;
    if (updateItemState.item && !updateItemState.handled) {
        if (updateItemState.method === "remove") {
            var mapItem = updateItemState.item;
            const unmapContent = (
                <Box>
                    Please confirm that you want to unmap FixtureNg <br/>'<b>{mapItem.fixtureNgName} ({CreateRoundUtil.toGameDateString(mapItem.startingAt)})</b>' <br/>with external<br/>
                    '<b>{mapItem.name}</b>'<br/>at provider<br/><b>{mapItem.providerId}</b><br/>with mapping id<br/><b>{mapItem.id}</b> .
                </Box>
            );
            updateDialog = (
                <ConfirmationDialog open={true} title="Unmap FixtureNg" message="Please confirm that you want to unmap FixtureNg." messageElement={unmapContent} onClose={onUnmapFixtureClose} />
            );            
        }
    }

    return (
        <div>
            {actionBox}
            <Box fontSize={10}>
                {info}{moreBtn}
            </Box>
            {/* <FixtureMappingTable items={itemState.items} onDelete={onDeleteItem} /> */}
            <ExtFixtureTable items={itemState.items} onMap={onDeleteItem} ngMode={true} />
            {updateDialog}
        </div>
    );
};

export default FixtureNgMappingView;

